(function(){
  'use strict';

  // ---- FAQ accordion ----
  document.querySelectorAll('.q').forEach(function(q){
    q.addEventListener('click', function(){
      var a = q.querySelector('.a');
      var open = q.classList.contains('open');
      document.querySelectorAll('.q').forEach(function(x){ x.classList.remove('open'); var xa=x.querySelector('.a'); if(xa) xa.style.maxHeight=0; });
      if(!open){ q.classList.add('open'); if(a) a.style.maxHeight = a.scrollHeight + 'px'; }
    });
  });

  // ---- Reserve countdown ----
  var cdEl = document.querySelector('[data-countdown]');
  if(cdEl){
    var target = new Date(cdEl.getAttribute('data-countdown') + 'T00:00:00');
    var d=cdEl.querySelector('[data-d]'), h=cdEl.querySelector('[data-h]'), m=cdEl.querySelector('[data-m]');
    function tick(){
      var t = target - new Date();
      if(isNaN(t) || t<0){ if(d)d.textContent='00'; if(h)h.textContent='00'; if(m)m.textContent='00'; return; }
      if(d) d.textContent = String(Math.floor(t/864e5)).padStart(2,'0');
      if(h) h.textContent = String(Math.floor(t/36e5)%24).padStart(2,'0');
      if(m) m.textContent = String(Math.floor(t/6e4)%60).padStart(2,'0');
    }
    tick(); setInterval(tick, 1000);
  }

  // ---- Build your box ----
  var bb = document.querySelector('[data-boxbuilder]');
  if(bb){
    var MAX = parseInt(bb.getAttribute('data-box-size'),10) || 12;
    var variantId = bb.getAttribute('data-variant-id');
    var rows = Array.prototype.slice.call(bb.querySelectorAll('[data-flavour]'));
    var baysWrap = bb.querySelector('[data-bays]');
    var warn = bb.querySelector('[data-warn]');
    var selOut = bb.querySelector('[data-selected]');
    var addBtn = bb.querySelector('[data-addbox]');
    var counts = rows.map(function(){ return 0; });

    // build empty bays
    var bays=[];
    for(var i=0;i<MAX;i++){
      var b=document.createElement('div'); b.className='bay';
      b.innerHTML='<svg viewBox="0 0 100 100"><use href="#fl-rose"></use></svg>';
      baysWrap.appendChild(b); bays.push(b);
    }
    function total(){ return counts.reduce(function(a,b){return a+b;},0); }
    function render(){
      var t = total();
      rows.forEach(function(row,idx){
        row.querySelector('[data-count]').textContent = counts[idx];
        row.querySelector('[data-inc]').disabled = t>=MAX;
        row.querySelector('[data-dec]').disabled = counts[idx]===0;
        row.classList.toggle('has', counts[idx]>0);
      });
      var glyphs=[];
      rows.forEach(function(row,idx){ for(var k=0;k<counts[idx];k++) glyphs.push(row.getAttribute('data-glyph')||'rose'); });
      bays.forEach(function(bay,i){
        if(i<glyphs.length){ bay.classList.add('full'); bay.querySelector('use').setAttribute('href','#fl-'+glyphs[i]); }
        else bay.classList.remove('full');
      });
      selOut.textContent = t + ' / ' + MAX;
      if(t===0){ warn.textContent='Select '+MAX+' cookies to continue.'; warn.style.color='var(--grey)'; }
      else if(t<MAX){ warn.textContent=(MAX-t)+' more to fill the box. Any combination — twelve of one is valid.'; warn.style.color='var(--gold)'; }
      else { warn.textContent='Box complete. Shipping is included at the member price.'; warn.style.color='var(--gold-lt)'; }
      addBtn.disabled = t!==MAX;
    }
    rows.forEach(function(row,idx){
      row.querySelector('[data-inc]').addEventListener('click', function(){ if(total()<MAX){ counts[idx]++; render(); } });
      row.querySelector('[data-dec]').addEventListener('click', function(){ if(counts[idx]>0){ counts[idx]--; render(); } });
    });
    addBtn.addEventListener('click', function(){
      if(total()!==MAX || !variantId) return;
      var selection = rows.filter(function(r,i){ return counts[i]>0; })
        .map(function(r,i){ var idx=rows.indexOf(r); return counts[idx]+' × '+r.getAttribute('data-name'); }).join(', ');
      addBtn.disabled = true; addBtn.textContent='Adding…';
      fetch('/cart/add.js', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ items:[{ id: parseInt(variantId,10), quantity:1, properties:{ 'Your selection': selection } }] })
      }).then(function(r){ return r.json(); })
        .then(function(){ window.location.href='/cart'; })
        .catch(function(){ addBtn.disabled=false; addBtn.textContent='Add Box to Cart'; alert('Could not add to cart. Make sure the box product is set in the theme editor.'); });
    });
    render();
  }
})();
